import shortid from "shortid";

export default [
  {
    tagName: "mj-column",
    attributes: {
      width: "33.333333%",
      "vertical-align": "top",
    },
    children: [],
    uid: shortid.generate(),
  },
  {
    tagName: "mj-column",
    attributes: {
      width: "33.333333%",
      "vertical-align": "top",
    },
    children: [],
    uid: shortid.generate(),
  },
  {
    tagName: "mj-column",
    attributes: {
      width: "33.333333%",
      "vertical-align": "top",
    },
    children: [],
    uid: shortid.generate(),
  },
];
